import { useAppSelector } from '../store/hooks';
import { PermissionsInterface } from '../store/sessionSlice';

export const EMPTY_PERMISSIONS: PermissionsInterface = {
  read_bundles: false,
  write_bundles: false,
  read_r2_files: false,
  write_r2_files: false,
  read_callrecorder: false,
  write_callrecorder: false,
  read_minecraft: false,
  write_minecraft: false,
  read_community: false,
  write_community: false,
  manage_admins: false,
};

// The backend serializes `permissions` (Admin::Capabilities) on login/launch —
// the frontend never derives access from the role string.
const usePermissions = (): PermissionsInterface => {
  return useAppSelector(state => state.session.admin.permissions) || EMPTY_PERMISSIONS;
};

export default usePermissions;
